import { useEffect, useState } from "react";
import { Phone, Mail, Check, Inbox } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/i18n/I18nContext";
import api from "@/lib/api";
import { Spinner } from "@/components/dashboard/DashBits";

export default function ContactRequests() {
  const { user } = useAuth();
  const { t } = useI18n();
  const isAdmin = user.role === "superadmin";
  const [reqs, setReqs] = useState(null);

  const load = () => api.get(isAdmin ? "/admin/contact-requests" : "/company/contact-requests").then(({ data }) => setReqs(data));
  useEffect(() => { load(); }, []);

  const markRead = async (r) => {
    if (isAdmin) return;
    try { await api.patch(`/company/contact-requests/${r.id}/read`); load(); } catch {}
  };

  return (
    <div>
      <h1 className="font-display font-bold text-3xl text-white">{t("dash.requestsTitle")}</h1>
      <p className="mt-1 text-zinc-400">{t("dash.requestsSub")}</p>

      {reqs === null ? <Spinner /> : (
        <div className="mt-6 space-y-3" data-testid="requests-list">
          {reqs.length === 0 && (
            <div className="rounded-2xl border border-white/10 bg-[#0d0d14] p-12 text-center">
              <Inbox className="w-8 h-8 text-zinc-600 mx-auto" />
              <p className="mt-3 text-zinc-500">{t("dash.noRequests")}</p>
            </div>
          )}
          {reqs.map((r) => (
            <div key={r.id} className={`rounded-2xl border p-5 ${r.read ? "border-white/10 bg-[#0d0d14]" : "border-cyan-500/30 bg-cyan-500/[0.04]"}`} data-testid={`request-${r.id}`}>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                <div className="min-w-0">
                  <div className="flex items-center gap-2.5 flex-wrap">
                    <p className="font-medium text-white">{r.first_name} {r.last_name}</p>
                    {r.profile_code && <span className="font-mono text-xs text-cyan-400">{r.profile_code}</span>}
                    {!r.read && <span className="w-2 h-2 rounded-full bg-cyan-400" />}
                  </div>
                  <div className="mt-2 flex flex-wrap gap-4 text-sm">
                    <a href={`tel:${r.phone}`} className="flex items-center gap-1.5 text-zinc-300 hover:text-cyan-400"><Phone className="w-3.5 h-3.5" /> {r.phone}</a>
                    <a href={`mailto:${r.email}`} className="flex items-center gap-1.5 text-zinc-300 hover:text-cyan-400"><Mail className="w-3.5 h-3.5" /> {r.email}</a>
                  </div>
                  {r.message && <p className="mt-2 text-sm text-zinc-400 bg-white/5 rounded-lg px-3 py-2">{r.message}</p>}
                  <p className="mt-2 text-xs text-zinc-600">{new Date(r.created_at).toLocaleString()}</p>
                </div>
                {!isAdmin && !r.read && (
                  <button onClick={() => markRead(r)} data-testid={`request-read-${r.id}`} className="inline-flex items-center gap-2 glass px-3.5 py-2 rounded-full text-sm text-white shrink-0"><Check className="w-4 h-4" /> {t("dash.markRead")}</button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
